import { render, staticRenderFns } from "./ThePasswordResetModal.vue?vue&type=template&id=f4928a22"
import script from "./ThePasswordResetModal.vue?vue&type=script&lang=js"
export * from "./ThePasswordResetModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports